/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCustomerNews} from '../api'

 export const useQueryGetCustomerNews = createReactQueryHook('getCustomerNews', getCustomerNews)
